import React, { useState } from "react";
import { Box, Button, IconButton, Menu, MenuItem, Tooltip, Typography } from "@mui/material";
import { Info, LockOpen } from "@mui/icons-material";
import { logoutUser } from "../../Redux/Actions/authAction";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import CropFreeIcon from "@mui/icons-material/CropFree";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import { LOCAL_STORAGE } from "Components/Constants/LocalStorage";
import { GET_LOCAL_STORAGE } from "Components/Constants/GetLocalStorage";
import { company } from "titum-custom/details";
import BackupService from "Service/Accounts/Backup.service";

export default function LogoutMenu(props) {

  const pjson = require("../../../package.json");

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [systemInfoAnchorEl, setSystemInfoAnchorEl] = useState(null)
  
  const dispatch = useDispatch();
  const defaultLocationSelected = useSelector((state) => state.defaultLocation);

  const open = Boolean(systemInfoAnchorEl)

  const [fullScreen, setFullScreen] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    dispatch(logoutUser());
  };

  const handleBackup = async () => {
    const res = await BackupService.download();
   
  };

  const handleClickSystemInfo = (e) => {
    setSystemInfoAnchorEl(e.currentTarget)
  }

  const handleCloseSystemInfo = () => {
    setSystemInfoAnchorEl(null)
  }


  var elem = document.documentElement;
  function openFullscreen() {
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Safari */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE11 */
      elem.msRequestFullscreen();
    }
    setFullScreen(true);
  }
  function closeFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      /* Safari */
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      /* IE11 */
      document.msExitFullscreen();
    }
    setFullScreen(false);
  }

  return (
    <div style={{ position: "absolute", right: 15, display: 'flex', alignItems: 'center' }}>
      <Typography
        sx={{
          display: {
            xs: 'none',
            md: 'inline-flex'
          }
        }}
      >
        Location: {JSON.parse(localStorage.getItem(LOCAL_STORAGE.BIZX_LOCATION)).name}
      </Typography>
      <IconButton
        color="inherit"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={() => {
          !fullScreen ? openFullscreen() : closeFullscreen();
        }}
        sx={{
          display: {
            xs: 'none',
            md: 'inline-flex'
          }
        }}
      >
        <p
          style={{ marginLeft: 5, marginRight: 5, textTransform: "uppercase" }}
        >
          {!fullScreen ? "Full Screen  [ F11 ]" : "Close  [ F11 ]"}
        </p>
        {!fullScreen ? <CropFreeIcon /> : <CloseFullscreenIcon />}
      </IconButton>
      
      {/* System info - Mobile layout */}
        {/* <Box sx={{
          display: {
            xs: 'flex',
            md: 'none'
          },
          justifyContent: {
            xs: 'end',
            md: 'none'
          }
        }}>
          <Tooltip
            id="basic-button"
            title="System Info"
            type="button"
            placement="top"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClickSystemInfo}
            sx={{
              // backgroundColor: '#ff0000',
              color: '#ffffff',
              minWidth: 'fit-content'
            }}
          >
            <Info />
          </Tooltip>
          <Menu
            id="basic-menu"
            anchorEl={systemInfoAnchorEl}
            open={open}
            onClose={handleCloseSystemInfo}
            slotProps={{
              list: {
                'aria-labelledby': 'basic-button',
              },
            }}
          >
            <MenuItem>
              Version: {pjson.version} &nbsp; - &nbsp; Solution By Titum (PVT) Ltd.
            </MenuItem>
            
            <MenuItem>
              Location: {JSON.parse(localStorage.getItem(LOCAL_STORAGE.BIZX_LOCATION)).name}
            </MenuItem>
          </Menu>
        </Box> */}
     
      <IconButton
        color="inherit"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <p
          style={{ marginLeft: 5, marginRight: 5, textTransform: "uppercase" }}
        >
          {" "}
          {props.user}
        </p>
        <LockOpen />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => {
          setAnchorEl(null);
        }}
      >
        <a href={company.backup} target="_blank">
        <MenuItem  style={{ color: "blue" }}  >Backup</MenuItem> 
        </a>
        <NavLink to="settings" exact>
          <MenuItem>Settings</MenuItem>
        </NavLink>
        <MenuItem onClick={handleClose}>Logout</MenuItem>
      </Menu>
    </div>
  );
}
